<template>
  <div class="mediakit-info">
    <h4>
      Buy traffic from
      <el-link :href="mediaKit.website_url" type="primary" target="_blank">
        {{ mediaKit.name }}
      </el-link>
      directly!
    </h4>
    <el-image :src="mediaKit.logo" :alt="mediaKit.name + ' logo'" />
    <div class="description">
      <p>{{ mediaKit.message }}</p>
      <el-row :gutter="20">
        <el-col :span="12" :xs="24">
          <div class="flex flex--space-between">
            <b>Stream</b>
            <span>{{ mediaKit.stream }}</span>
          </div>
        </el-col>
        <el-col :span="12" :xs="24">
          <div class="flex flex--space-between">
            <b>SimilarWeb Rank</b>
            <span v-if="mediaKit.similarweb_rank">{{
              mediaKit.similarweb_rank
            }}</span>
            <span v-else>Unknown</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="24">
          <div class="flex flex--space-between">
            <b>Traffic Quality</b>
            <TrafficQuality :quality="mediaKit.quality" />
          </div>
        </el-col>
        <el-col :span="12" :xs="24">
          <div class="flex flex--space-between">
            <b>Cost model</b>
            <span>CPM</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TrafficQuality from './TrafficQuality.vue'

export default defineComponent({
  name: 'MediakitInfo',
  components: {
    TrafficQuality
  },
  props: {
    mediaKit: {
      type: Object,
      required: true
    }
  }
})
</script>

<style lang="scss" scoped>
.mediakit-info {
  text-align: center;
}
.el-image {
  max-height: 200px;
}
.description {
  width: 500px;
  margin: 10px auto;
}
.el-row:first-child {
  margin-bottom: 30px;
}
@media only screen and (max-width: 500px) {
  .description {
    width: 100%;
  }
}
</style>
